import React from 'react'
import {
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions } from '@coreui/icons'

// Renders a single action as a plain button, or 2+ actions as a kebab dropdown.
const RowActionsMenu = ({ actions = [] }) => {
  const visible = actions.filter((a) => a && !a.hidden)
  if (visible.length === 0) return null

  if (visible.length === 1) {
    const action = visible[0]
    return (
      <CButton
        size="sm"
        color={action.color || 'primary'}
        variant={action.variant || 'outline'}
        disabled={action.disabled}
        onClick={action.onClick}
      >
        {action.label}
      </CButton>
    )
  }

  // These menus live inside .ge-datatable's scroll container, which clips anything drawn
  // outside it — portal renders the menu at <body> so it can overflow the table.
  return (
    <CDropdown alignment="end" placement="bottom-end" portal>
      <CDropdownToggle
        color="secondary"
        variant="ghost"
        size="sm"
        caret={false}
        className="ge-row-actions-toggle"
        aria-label="Row actions"
      >
        <CIcon icon={cilOptions} />
      </CDropdownToggle>
      <CDropdownMenu className="ge-row-actions-menu">
        {visible.map((action) => (
          <CDropdownItem
            key={action.label}
            disabled={action.disabled}
            className={action.danger ? 'text-danger' : undefined}
            onClick={action.onClick}
          >
            {action.label}
          </CDropdownItem>
        ))}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default RowActionsMenu
